export const TEST_IDS = {
  HERO_SKELETON: 'hero-skeleton',
  MENU_BUTTON_DESKTOP: 'menu-button-desktop',
  MENU_LINK_DESKTOP: 'menu-link-desktop',
  HEADER_ACTION_LINKS: 'app-listing__header-action-links',
  SERVER_EOL_MESSAGE: 'server-eol-warning-message',
  SERVER_EOS_MESSAGE: 'server-eos-warning-message',
  IC_INFO_MESSAGE: 'isolated-cloud--info-message',
  AGC_INFO_ROA_WARNING_MESSAGE: 'government-cloud-roa-warning-message',
  IC_INFO_ROA_WARNING_MESSAGE: 'isolated-cloud-roa-warning-message',
  AGC_INFO_MESSAGE: 'government-cloud--info-message',
  DATA_CENTER_EOS_MESSAGE: 'data-center-eos-warning-message',
} as const;
